import {Progress} from "@mantine/core";
import {isNil, reverse, sortBy} from "lodash";

import classes from "./Rating.module.scss";
import type {Rating} from "../../graphql/types";
import StarRating from "../StarRating";

export interface RatingProps {
  rating: Rating;
}

export default function Rating({rating}: RatingProps) {
  // Null state
  if (isNil(rating.average)) {
    return (
      <div className={classes.rating}>
        <div className={classes.title}>Not rated yet</div>
      </div>
    );
  }

  // Rated
  return (
    <div className={classes.rating}>
      <div className={classes.title}>
        Ratings ({rating.count.toLocaleString()})
      </div>
      <StarRating rating={rating.average} readOnly />
      <div className={classes.distribution}>
        {reverse(sortBy(rating.distribution, it => it.rating)).map(count => (
          <div key={count.rating} className={classes.distributionItem}>
            <div>{count.rating} stars</div>
            <div className={classes.progress}>
              <Progress value={count.count / (rating.count / 100)} />
            </div>
            <div>{count.count.toLocaleString()}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
